import React from "react";
import { Info, InfoText } from "./DashboardDetailInfoStyle";
import MoreInfoIcon from "assets/images/icons/infomore.svg";
import InfoProvisionGuide from "components/common/InfoGuide/InfoProvisionGuide";
import { useDispatch } from "react-redux";
import { toggleModal } from "redux/modules/dashboard";

const DashboardDetailInfo = ({ top, left }) => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  var fetchDate = new Date(year, month, day, 10, 30);

  const dispatch = useDispatch();

  function dataDate() {
    const now = new Date();
    if (now > fetchDate) {
      return `${year}.${month}.${now.day}일 기준`;
    } else {
      return `${year}.${month}.${day}일 기준`;
    }
  }

  return (
    <>
      <Info>
        <InfoText>{dataDate()}</InfoText>
        <InfoText>
          정보 제공 안내
          <img
            className="moreinfo-icon"
            src={MoreInfoIcon}
            alt="more info"
            onClick={() => dispatch(toggleModal())}
          />
        </InfoText>
      </Info>
      <InfoProvisionGuide top={top} left={left} />
    </>
  );
};

export default DashboardDetailInfo;
